import { baseApi } from './baseApi'

export type RetellOutboundActivityItem = {
  id: string
  orderId: number
  patientId: number | null
  patientName: string | null
  bucket: string
  callReason: string
  callWindowType: string
  status: string
  suppressionReason: string | null
  localCallDate: string
  scheduledFor: string | null
  retellCallId: string | null
  recordingUrl: string | null
  transferred: boolean
  transferredAt: string | null
  deferralCount: number
  lastDeferralReason: string | null
  createdAt: string
  updatedAt: string
}

export type RetellOutboundActivityResult = {
  items: RetellOutboundActivityItem[]
  currentPage: number
  totalItems: number
}

export type RetellOutboundActivityQuery = {
  status?: string
  buckets?: string[]
  transferred?: boolean
  search?: string
  fromDate?: string
  toDate?: string
  sortBy?: 'createdAt' | 'scheduledFor'
  sortDir?: 'asc' | 'desc'
  page?: number
  size?: number
}

export const retellOutboundActivityApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getRetellOutboundActivity: builder.query<RetellOutboundActivityResult, RetellOutboundActivityQuery>({
      query: (params) => ({ url: '/lab/settings/retell-outbound/attempts', params }),
    }),
  }),
})

export const { useGetRetellOutboundActivityQuery } = retellOutboundActivityApi
